import { __extends, __assign } from 'tslib';
import { PLAY_EVENT, Plugin, H5Player } from '@tencent/thumbplayer-h5';
import { urlTool, netTool } from '@tencent/thumbplayer-core';

var CGI = 'https://zbpbaccess.video.qq.com/trpc.ten_video_live.trpc_live_poll.LiveDetailService/pollLiveInfo';

var Poller = /** @class */ (function () {
    function Poller() {
        var _this = this;
        /** 轮询间隔，会根据接口返回变化 */
        this.pollInterval = 3e4;
        this.timeout = 5e3;
        this.maxRetryTimes = -1;
        this.loadInfo = function () {
            if (!_this.reqData)
                return;
            var url = "".concat(CGI, "?").concat(urlTool.object2string(_this.reqData, '&'));
            var param = { url: url };
            if (_this.timeout !== -1) {
                param.timeout = _this.timeout;
            }
            return netTool.xhr(param).then(_this.onCGIComplete)
                .catch(function (err) {
                _this.onCGIError(err);
                throw err;
            });
        };
        this.onCGIComplete = function (ret) {
            var _a;
            _this.clearTimer();
            _this.errorRetryTimes = 0;
            var data;
            try {
                // netTool.xhr封装了一层data
                data = JSON.parse(ret === null || ret === void 0 ? void 0 : ret.data).data;
            }
            catch (err) {
                _this.onCGIError(err);
            }
            if ((data === null || data === void 0 ? void 0 : data.err_code) === 0) {
                // 先设置settimeout
                var pollTimeOut = Number(data.interval);
                if (!isNaN(pollTimeOut) && pollTimeOut > 0) {
                    _this.pollInterval = pollTimeOut * 1000;
                }
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                _this.pollTimerID = window.setTimeout(_this.loadInfo, _this.pollInterval);
                // 再回调数据处理（可能会在回调中取消settimeout）
                (_a = _this.onCallback) === null || _a === void 0 ? void 0 : _a.call(_this, null, data);
            }
            else {
                _this.onCGIError(data);
            }
        };
    }
    /** 发起请求并轮询 */
    Poller.prototype.start = function (reqData, onCallback) {
        if (reqData === void 0) { reqData = {}; }
        this.reqData = reqData;
        this.errorRetryTimes = 0;
        this.onCallback = onCallback;
        return this.loadInfo();
    };
    /** 终止轮询 */
    Poller.prototype.dispose = function () {
        this.clearTimer();
        this.reqData = null;
        this.onCallback = null;
    };
    Poller.prototype.onCGIError = function (err) {
        var _a;
        this.clearTimer();
        this.errorRetryTimes += 1;
        if (this.maxRetryTimes === -1 || this.errorRetryTimes <= this.maxRetryTimes) {
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.pollTimerID = window.setTimeout(this.loadInfo, this.pollInterval);
        }
        else {
            (_a = this.onCallback) === null || _a === void 0 ? void 0 : _a.call(this, err, null);
        }
    };
    Poller.prototype.clearTimer = function () {
        if (this.pollTimerID > 0) {
            clearTimeout(this.pollTimerID);
            this.pollTimerID = 0;
        }
    };
    return Poller;
}());

/** 直播状态，对应接口返回的 liveStatus 字段 */
var LiveStatus;
(function (LiveStatus) {
    /** 直播未开始 */
    LiveStatus[LiveStatus["READY"] = 3] = "READY";
    /** 直播中 */
    LiveStatus[LiveStatus["PLAYING"] = 1] = "PLAYING";
    /** 直播结束 */
    LiveStatus[LiveStatus["OVER"] = 2] = "OVER";
})(LiveStatus || (LiveStatus = {}));
/** 插件广播的事件 */
var LIVE_EVENTS = {
    statusChange: 'statusChange',
};
var LivepollPlugin = /** @class */ (function (_super) {
    __extends(LivepollPlugin, _super);
    function LivepollPlugin(player, config) {
        var _this = _super.call(this, player) || this;
        /** 当前直播状态 */
        _this.status = LiveStatus.READY;
        /** 轮询器，可以设置一些请求相关的配置参数 */
        _this.poller = new Poller();
        /** 结束轮询，清空数据 */
        _this.destory = function () { return _this.poller.dispose(); };
        /** 处理直播状态轮询返回，参数风格类似node回调 */
        _this.handlerLivePollData = function (err, data) {
            if (err || !data)
                return;
            var status = Number(data.play_status);
            if (status !== _this.status) {
                _this.emit(LIVE_EVENTS.statusChange, { old: _this.status, new: status, raw: data });
                if (status === LiveStatus.OVER) {
                    _this.player.stop();
                    _this.destory();
                }
            }
            _this.status = status;
        };
        _this.config = __assign(__assign({}, player.config.livepollConfig), config);
        var _a = _this.config, livepid = _a.livepid, _b = _a.autolisten, autolisten = _b === void 0 ? true : _b, _c = _a.timeout, timeout = _c === void 0 ? 5e3 : _c;
        _this.poller.timeout = timeout;
        if (livepid)
            _this.livepid = livepid;
        if (autolisten) {
            player.addListener(PLAY_EVENT.FIRST_PLAYING, function () { return _this.request(); });
            player.addListener(PLAY_EVENT.STOPED, _this.destory);
        }
        return _this;
    }
    /** 发起请求 */
    LivepollPlugin.prototype.request = function (param) {
        if (param === null || param === void 0 ? void 0 : param.livepid) {
            this.livepid = param.livepid;
        }
        // 清空上一次请求
        this.poller.dispose();
        if (!this.livepid) {
            // do not requst without livepid
            return;
        }
        return this.poller.start({
            pid: this.livepid,
        }, this.handlerLivePollData);
    };
    LivepollPlugin.pluginName = 'live-poll';
    return LivepollPlugin;
}(Plugin));
H5Player.registerPlugin(LivepollPlugin.pluginName, LivepollPlugin);

export { LIVE_EVENTS, LiveStatus as LIVE_STATUS, LiveStatus, LivepollPlugin };
